/**
 * @description LocalStorage 本地存储
 * @author lentoo
 * @date 2019-02-22
 * @export
 * @class LocalStorage
 */
export class LocalStorage {
  /**
   * @description 存储数据
   * @author lentoo
   * @date 2019-02-22
   * @static
   * @param {*} key key
   * @param {*} value value
   * @memberof LocalStorage
   */
  static setItem (key, value) {
    if (typeof value === 'string') {
      localStorage.setItem(key, JSON.stringify({
        _format: 'string',
        value
      }))
    }
    if (typeof value === 'object') {
      localStorage.setItem(key, JSON.stringify({
        _format: 'object',
        value
      }))
    }
  }
  /**
   * @description 通过 key 返回存储的数据，如果没有，返回 null
   * @author lentoo
   * @date 2019-02-22
   * @static
   * @param {*} key key
   * @returns
   * @memberof LocalStorage
   */
  static getItem (key) {
    const val = localStorage.getItem(key)
    if (val === null) {
      return null
    }
    return JSON.parse(val).value
  }
  static removeItem (key) {
    localStorage.removeItem(key)
  }
}
export class SessionStorage {
  /**
   * @description 存储数据
   * @author lentoo
   * @date 2019-02-22
   * @static
   * @param {*} key key
   * @param {*} value value
   * @memberof SessionStorage
   */
  static setItem (key, value) {
    if (typeof value === 'string') {
      sessionStorage.setItem(key, JSON.stringify({
        _format: 'string',
        value
      }))
    }
    if (typeof value === 'object') {
      sessionStorage.setItem(key, JSON.stringify({
        _format: 'object',
        value
      }))
    }
  }
  /**
   * @description 通过 key 返回存储的数据，如果没有，返回 null
   * @author lentoo
   * @date 2019-02-22
   * @static
   * @param {*} key key
   * @returns
   * @memberof LocalStorage
   */
  static getItem (key) {
    const val = sessionStorage.getItem(key)
    if (val === null) {
      return null
    }
    return JSON.parse(val).value
  }
  static removeItem (key) {
    sessionStorage.removeItem(key)
  }
}
/**
 * @description 用于回到页面顶部
 * @author txw
 * @param {dom} elem 最外层的dom，优先建议使用ref获取节点
 * @param {number} speed 速度
 * @date 2019-06-21
 * @export
 */
export const scrollTop = (elem, speed = 5) => {
  let oDom = elem.$el || elem // 兼容vue组件跟html标签
  let timer = null
  timer = requestAnimationFrame(function fn () {
    let oTop = oDom.scrollTop
    if (oTop > 0) {
      oDom.scrollTop = oTop - (oTop / speed)
      timer = requestAnimationFrame(fn)
    } else {
      cancelAnimationFrame(timer)
    }
  })
}
/**
 * @description 用于向页面底部走
 * @author cc
 * @param {dom} elem 最外层的dom，优先建议使用ref获取节点
 * @param {number} speed 速度
 * @date 2019-11-14
 * @export
 */
export const scrollBottom = (elem, speed = 5) => {
  let oDom = elem.$el || elem // 兼容vue组件跟html标签
  let timer = null
  timer = requestAnimationFrame(function fn () {
    let oTop = oDom.scrollTop
    oDom.scrollTop = oTop + (oTop / speed)
    timer = requestAnimationFrame(fn)
    // if (oDom.scrollTop > 2000) {
    if (oDom.scrollTop > 1600) {
      cancelAnimationFrame(timer)
    }
  })
}
/**
 * @description 用于获取节点的样式
 * @author txw
 * @param {dom} elem 要获取样式的节点,优先建议使用ref获取节点
 * @param {*} prop 要获取的属性
 * @date 2019-06-21
 * @export
 * @returns 样式值
 */
export const getStyle = (elem, prop) => {
  if (window.getComputedStyle) {
    return window.getComputedStyle(elem, null)[prop]
  } else {
    return elem.currentStyle[prop]
  }
}
/**
 * @description JSONP解跨域
 * @author cc
 * @param {dom} url 请求接口链接
 * @date 2019-11-20
 */
export const JsonP = (url) => {
  let newScript = document.getElementsByTagName('html')[0]
  let newHead = newScript.getElementsByTagName('head')[0]
  let script = document.createElement('script')
  script.type = 'text/javascript'
  script.src = url
  newHead.appendChild(script)
}
/**
 * @description 获取一个cookie
 * @author cc
 * @param {dom} objName cookie名字
 * @date 2019-11-21
 */
export const getcookie = (objName) => {
  let arrStr = document.cookie.split('; ')
  for (let i = 0; i < arrStr.length; i++) {
    let temp = arrStr[i].split('=')
    if (temp[0] === objName) return unescape(temp[1]) // 解码
  }
  return ''
}
/**
 * @description 与安卓配合，判断是不是首页
 * @author cc
 * @date 2019-11-30
 */
// 首页点击返回弹出退出事件
export const isHomePage = () => {
  let isHomepage = document.getElementById('is_home_page')
  if (isHomepage === '1') {
    window.TWAPI.onBackDown()
    return true
  }
  return false
}
// 原生的webview触发js代码，这里是安卓的点击返回事件
export const clickBackFunction = () => {
  // 判断是不是首页，是就直接调用java写的接口弹出退出框
  if (isHomePage()) {
    return
  }

  let reg = /order\/success/i
  if (reg.test(document.URL)) {
    // BackLayer()
    return true
  }
}
/**
 * @description 处理时间
 * @author txw
 * @date 2019-12-24
 */
export const myDate = new class {
  constructor (date = new Date()) {
    this.nowDayOfWeek = date.getDay() // 今天本周的第几天
    this.nowDay = date.getDate() // 当前日
    this.nowMonth = date.getMonth() // 当前月
    this.nowYear = date.getFullYear() // 当前年
    let lastMonthDate = new Date() // 上月日期
    lastMonthDate.setDate(1)
    lastMonthDate.setMonth(lastMonthDate.getMonth() - 1)
    this.lastYear = lastMonthDate.getYear()
    this.lastMonth = lastMonthDate.getMonth()
  }
  /**
   * @description 格式化时间
   * @param {number | object} value 可以传已经被new Date()处理过 or 10位时间戳 or 13位时间戳
   * @param {string} type 默认返回yyyy-mm-dd hh:mm 可配置type = 'yyyy-mm-dd' 返回年月日
   * @returns 默认返回yyyy-mm-dd hh : mm
   */
  formatDate (value, type) {
    let date = ''
    if (typeof value === 'object') {
      date = value
    } else {
      if (value.length === 10) {
        date = new Date(value * 1000)
      } else {
        date = new Date(value)
      }
    }
    let y = date.getFullYear() + '-'
    let m = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
    let d = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate()) + ' '
    let h = (date.getHours() < 10 ? '0' + (date.getHours()) : date.getHours()) + ':'
    let mm = (date.getMinutes() < 10 ? '0' + (date.getMinutes()) : date.getMinutes())
    if (type === 'yyyy-mm-dd') {
      return y + m + d
    } else {
      return y + m + d + h + mm
    }
  }
  /**
   * @description 返回本周时间 [周一，当天]
   */
  getWeekDate () {
    const weekEndDate = new Date(this.nowYear, this.nowMonth, this.nowDay - this.nowDayOfWeek)
    return [this.formatDate(weekEndDate, 'yyyy-mm-dd'), this.formatDate(new Date(), 'yyyy-mm-dd')]
  }
  /**
   * @description 返回上周的时间
   */
  getLastWeekDate () {
    const weekStartDate = new Date(this.nowYear, this.nowMonth, this.nowDay - this.nowDayOfWeek - 7)
    const weekEndDate = new Date(this.nowYear, this.nowMonth, this.nowDay - this.nowDayOfWeek - 1)
    return [this.formatDate(weekStartDate, 'yyyy-mm-dd'), this.formatDate(weekEndDate, 'yyyy-mm-dd')]
  }
  /**
   * @description 返回本月的时间
   */
  getMonthDate () {
    const monthStartDate = new Date(this.nowYear, this.nowMonth, 1)
    return [this.formatDate(monthStartDate, 'yyyy-mm-dd'), this.formatDate(new Date(), 'yyyy-mm-dd')]
  }
  /**
   * @description 返回上个月的时间
   */
  getLastMonthDate () {
    const lastMonthStartDate = new Date(this.nowYear, this.lastMonth, 1)
    const lastMonthEndDate = new Date(this.nowYear, this.lastMonth, this.getMonthDays(this.lastMonth))
    return [this.formatDate(lastMonthStartDate, 'yyyy-mm-dd'), this.formatDate(lastMonthEndDate, 'yyyy-mm-dd')]
  }
  /**
   * @description 获取某月的天数
   */
  getMonthDays (myMonth) {
    const monthStartDate = new Date(this.nowYear, myMonth, 1)
    const monthEndDate = new Date(this.nowYear, myMonth + 1, 1)
    const days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24)
    return days
  }
}()
/**
 * @description 用于常用限制字数
 * @author txw
 * @param value 输入的内容  limit 最多输入的文字数量
 * @returns conetnt 200/200  value 内容
 */
export const wordCountLimit = (value, limit = 200) => {
  if (String(value).length > 200) {
    value = value.substring(0, 200)
  }
  return {
    msg: `${limit - value.length}/${limit}`,
    value: value
  }
}
/**
 * @description 节流
 * @author txw
 *@param  fn是我们需要包装的事件回调, interval是时间间隔的阈值
 */
export const throttle = (fn, interval) => {
  // last为上一次触发回调的时间
  let last = 0
  // 将throttle处理结果当作函数返回
  return function () {
    // 保留调用时的this上下文
    let context = this
    // 保留调用时传入的参数
    let args = arguments
    // 记录本次触发回调的时间
    let now = +new Date()
    // 判断上次触发的时间和本次触发的时间差是否小于时间间隔的阈值
    if (now - last >= interval) {
      // 如果时间间隔大于我们设定的时间间隔阈值，则执行回调
      last = now
      fn.apply(context, args)
    }
  }
}
/**
 * @description 防抖
 * @author txw
 *@param  fn是我们需要包装的事件回调, wait是时间间隔的阈值
 */
export const debounce = (func, wait) => {
  let timeout
  return function () {
    let context = this
    let args = arguments
    clearTimeout(timeout)
    timeout = setTimeout(function () {
      func.apply(context, args)
    }, wait)
  }
}
/**
 * @description 用正则验证一些值
 * @param type 类型  value 值
 * @returns Boolean
 * @author txw
 */
export const verification = (type, value) => {
  let regObj = {
    mobile: /^[1](([3][0-9])|([4][5-9])|([5][0-3,5-9])|([6][5,6])|([7][0-8])|([8][0-9])|([9][1,8,9]))[0-9]{8}$/,
    telephone: /^0\d{2,3}-?\d{7,8}$/
  }
  return regObj[type].test(value)
}
/**
 * @description 判断手机机型
 * @type {{isAndroid: boolean, isIOS: boolean}}
 */
export const judgeDeviceType = (function () {
  const ua = window.navigator.userAgent.toLocaleLowerCase()
  const isIOS = /iphone|ipad|ipod/.test(ua)
  const isAndroid = /android/.test(ua)
  return {
    isIOS: isIOS,
    isAndroid: isAndroid
  }
}())
